export default {
  // attackDataLen(state) {
  //   return state.attackData.length;
  // },
  // currentAttacks(state) {
  //   const {
  //     attackIndex: { start, end },
  //     attackData
  //   } = state;
  //   const currentAttackArr = [];
  //   if (start === end && end === 0) return currentAttackArr;
  //   for (let i = start; i <= end; i++) {
  //     currentAttackArr.push(attackData[i]);
  //   }

  //   return currentAttackArr;
  // },
  // getAttacksByGeocode(state, getters) {
  //   return geocode => {
  //     return getters.currentAttacks.filter(item => {
  //       return item.geocountry === geocode;
  //     });
  //   };
  // },
  // currentAttacksGeoCountry(state) {
  //   // return a unique list of geocountrycodes
  //   return [...new Set(state.currentAttacks.map(i => i.geocountry))];
  // }
};
